export default "__VITE_ASSET__CeJGmbKY__"